import { CreditFacilityProfitOverviewInsightsGqlDataGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';
import {
  CoreBorrowingBaseInsightsKeys,
  PortfolioChartConfig,
} from '../shared/portfolioChartUtils';
import { colors, transparency } from 'packages/common-frontend/colors';

export const collectionsAccountChartConfig: PortfolioChartConfig<CoreBorrowingBaseInsightsKeys> = {
  totalCollectionsAccountCash: {
    chartType: 'bar',
    field: 'totalCollectionsAccountCash',
    label: 'Collections Balance',
    format: 'currency',
    color: `${colors.chart.sky}${transparency[50]}`,
    activeColor: colors.chart.sky,
  },
};

export const chargeOffAndDelinquentOverviewChartConfig: PortfolioChartConfig<
  keyof CreditFacilityProfitOverviewInsightsGqlDataGQLType
> = {
  chargedOffPercentageOfTotalExposure: {
    chartType: 'line',
    field: 'chargedOffPercentageOfTotalExposure',
    label: 'Charge Off %',
    format: 'percentage',
    color: colors.chart.jasmine,
  },
  delinquentPercentageOfTotalExposure: {
    chartType: 'line',
    field: 'delinquentPercentageOfTotalExposure',
    label: 'Delinquent %',
    format: 'percentage',
    color: colors.chart.teal,
  },
};

export const daysPastDueChartConfig: PortfolioChartConfig<
  keyof CreditFacilityProfitOverviewInsightsGqlDataGQLType
> = {
  percentExposureDaysPastDue0: {
    chartType: 'bar',
    field: 'percentExposureDaysPastDue0',
    label: '0 Days Past Due',
    format: 'percentage',
    color: `${colors.black[40]}${transparency[50]}`,
    activeColor: colors.black[40],
    defaultInactive: true,
  },
  percentExposureDaysPastDue1to30: {
    chartType: 'bar',
    field: 'percentExposureDaysPastDue1to30',
    label: '1-30 Days Past Due',
    format: 'percentage',
    color: `${colors.brick[500]}${transparency[50]}`,
    activeColor: colors.brick[500],
  },
  percentExposureDaysPastDue31to60: {
    chartType: 'bar',
    field: 'percentExposureDaysPastDue31to60',
    label: '31-60 Days Past Due',
    format: 'percentage',
    color: `${colors.brick[600]}${transparency[50]}`,
    activeColor: colors.brick[600],
  },
  percentExposureDaysPastDue61to90: {
    chartType: 'bar',
    field: 'percentExposureDaysPastDue61to90',
    label: '61-90 Days Past Due',
    format: 'percentage',
    color: `${colors.brick[700]}${transparency[50]}`,
    activeColor: colors.brick[700],
  },
  percentExposureDaysPastDue91to120: {
    chartType: 'bar',
    field: 'percentExposureDaysPastDue91to120',
    label: '91-120 Days Past Due',
    format: 'percentage',
    color: `${colors.brick[800]}${transparency[50]}`,
    activeColor: colors.brick[800],
  },
  percentExposureDaysPastDue121plus: {
    chartType: 'bar',
    field: 'percentExposureDaysPastDue121plus',
    label: '121+ Days Past Due',
    format: 'percentage',
    color: `${colors.brick[950]}${transparency[50]}`,
    activeColor: colors.brick[950],
  },
};
